import React from 'react';
import PropTypes from 'prop-types';

import { Bert } from 'meteor/themeteorchef:bert';
import { InputAdornment, IconButton, Box } from '@mui/material';
import PlagiarismOutlinedIcon from '@mui/icons-material/PlagiarismOutlined';

import { renderTextField } from '../MaterialMUIComponent/index';

import { URL_REGEX, YOUTUBE_URL_REGEX } from '../../../api/Videos/Videos';
import Loading from '../Loading';

const UploadFileComponent = ({ linkValueProp, handleValueLink, labelProp }) => {
  const [linkValue, setLinkValue] = React.useState(linkValueProp);
  const [isValid, setIsValid] = React.useState(true);
  const [isLoading, setIsLoading] = React.useState(false);
  const handleUrl = link => {
    if (link !== '') {
      const isValidLink = YOUTUBE_URL_REGEX.test(link) || URL_REGEX.test(link);
      setIsValid(isValidLink);
    }
    handleValueLink(link);
    setLinkValue(link);
  };

  const loadInputFile = () => {
    const handleFileImportCSV = async event => {
      const file = event.target.files[0];
      event.preventDefault();

      if (!file) {
        Bert.alert('Selecciona un archivo primero', 'danger');
        return;
      }
      const formData = new FormData();
      formData.append('file', file);
      formData.append('disc', 'data3');

      try {
        const response = await fetch('https://sd1.d3.ipsilum.com/upload', {
          method: 'POST',
          body: formData,
          mode: 'cors',
          credentials: 'omit',
          referrerPolicy: 'no-referrer'
        });
        const respuesta = await response.json();
        const urlFile = respuesta.data.link;
        handleUrl(urlFile);
      } catch (error) {
        console.error('Error:', error);
      }
    };

    const inputElement = document.createElement('input');
    inputElement.type = 'file';
    inputElement.onchange = handleFileImportCSV;
    inputElement.click();
    setIsLoading(false);
  };

  React.useEffect(() => {
    setLinkValue(linkValueProp);
  }, [linkValueProp]);

  return (
    <>
      <Box
        sx={{
          display: 'flex',
          mb: 2,
          width: '95%'
        }}
      >
        {renderTextField({
          label: labelProp,
          moreProps: {
            key: 'textfield-upload-file',
            helperText: isValid ? '' : 'Url not valid',
            disabled: isLoading,
            fullWidth: true,
            onChange: event => handleUrl(event.target.value),
            value: linkValue,
            InputProps: {
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    disabled={isLoading}
                    variant="contained"
                    aria-label="upload"
                    component="label"
                    style={{
                      color: '#2A3F90'
                    }}
                    onClick={() => {
                      setIsLoading(true);
                      loadInputFile();
                    }}
                  >
                    {!isLoading ? <PlagiarismOutlinedIcon /> : <Loading />}
                  </IconButton>
                </InputAdornment>
              )
            }
          }
        })}
      </Box>
    </>
  );
};
UploadFileComponent.defaultProps = {
  linkValueProp: '',
  labelProp: 'File link'
};

UploadFileComponent.propTypes = {
  linkValueProp: PropTypes.string,
  labelProp: PropTypes.string,
  handleValueLink: PropTypes.func.isRequired
};

export default UploadFileComponent;
